var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64522 0.190504C3.51669 0.069907 3.34325 0.00279522 3.163 0.00391052C2.98274 0.00502582 2.81041 0.074277 2.68386 0.196452L0.209141 2.58861C0.142795 2.64837 0.0897755 2.72026 0.0532458 2.8C0.0167161 2.87974 -0.00257578 2.9657 -0.00347809 3.05274C-0.00438039 3.13979 0.0131248 3.22613 0.0479927 3.30663C0.0828606 3.38713 0.134378 3.46014 0.19947 3.52129C0.264563 3.58244 0.341897 3.63049 0.426859 3.66257C0.511822 3.69464 0.602672 3.71009 0.693991 3.70799C0.78531 3.70589 0.875227 3.68628 0.958376 3.65034C1.04152 3.6144 1.1162 3.56285 1.17796 3.49878L2.50081 2.22006L2.56198 9.73052C2.56338 9.90243 2.63639 10.0669 2.76494 10.1876C2.8935 10.3084 3.06706 10.3756 3.24746 10.3745C3.42787 10.3734 3.60032 10.304 3.7269 10.1817C3.85347 10.0593 3.92379 9.89401 3.92239 9.7221L3.8918 5.96687L3.86122 2.21165L5.20476 3.47387C5.33464 3.58757 5.50569 3.64884 5.68189 3.64479C5.85808 3.64074 6.02566 3.57167 6.14932 3.45214C6.27298 3.33261 6.34306 3.17194 6.3448 3.004C6.34654 2.83605 6.27981 2.67393 6.15866 2.5518L3.64522 0.190504Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.70a334c323dd7006268a17237a5151be.svg";
export { ForwardRef as ReactComponent };